module.exports = __webpack_public_path__ + "img/shortcut-news.f6bee05d.png";